/* eslint-disable arrow-body-style */
import { mapActions, mapGetters, mapState } from 'vuex';
import linkTile from '@/components/generics/link-tile/link-tile.vue';
import contentHeader from '@/components/generics/content-header/content-header.vue';
import faq from '@/components/support/faq/faq.vue';
import openBookIcon from '@/assets/icons/support/book.svg';
import faqIcon from '@/assets/icons/support/faq.svg';
import logoIcon from '@/assets/branding/logo5.png';
import videosIcon from '@/assets/icons/support/tutorial.svg';
import { formMixin, validators } from '@/components/forms/mixin';
import loaderMixin from '@/mixins/loader';
import userAgentMixin from '@/mixins/userAgent';
import supportMixin from '@/mixins/support';
import { MODALS } from '@/components/app/app-modals/app-modals';
import accountDesktopHeader from '@/components/account/account-desktop-header/account-desktop-header.vue';
import { BRAND } from '@/components/brand-name/brand-name.js';

const TICKET_SEND_MESSAGE = 'Message received!';
// const FILE_PROCESSING_ERROR = 'An error occured while processing your file';

export default {
  props: {
    title: {
      type: String,
      default: 'Help and Support',
    },
  },
  components: {
    accountDesktopHeader,
    linkTile,
    contentHeader,
    faq,
  },
  mixins: [
    formMixin,
    loaderMixin,
    supportMixin,
    userAgentMixin,
  ],
  data() {
    return {
      announcements: [],
      fields: {
        email: '',
        subject: null,
        message: '',
      },
      files: [],
    };
  },
  metaInfo() {
    return {
      title: 'Support',
    };
  },
  computed: {
    ...mapGetters('user', ['isLoggedIn']),
    ...mapState('user', ['userData']),
    ...mapState('support', ['ticketTypes']),
    ...mapState('app', ['systemEmails']),
    allowedExtensions() {
      return ['bmp', 'gif', 'jpeg', 'jpg', 'pdf', 'png'];
    },
    acceptAllowedExtensions() {
      return this.allowedExtensions.map((ext) => `.${ext}`).join(', ');
    },
    isAnyFileInvalid() {
      return this.files.some((i) => {
        return !this.allowedExtensions.some(s => i.name.endsWith(s));
      });
    },
    items() {
      const items = [
        {
          href: '/support/what-is-predictit',
          icon: logoIcon,
          title: `What is ${BRAND}?`,
          subtitle: '',
        },
        {
          href: '/support/how-to-trade-on-predictit',
          icon: openBookIcon,
          title: `How to Trade`,
          subtitle: '',
        },
        {
          href: '/support/faq',
          icon: faqIcon,
          title: 'FAQs',
        },
        // {
        //   href: '/support/community-forums',
        //   icon: forumIcon,
        //   title: 'Community Forums',
        //   subtitle: '',
        // },
      ];

      if (!this.showVideos) {
        items.push({
          href: '/support/videos',
          icon: videosIcon,
          title: 'Videos',
          subtitle: '',
        });
      }

      return items;
    },
    subjectOptions() {
      return this.ticketTypes === null ? [] : this.ticketTypes;
    },
    isUploadEnabled() {
      // return !(this.isIos && this.isStandalone);
      return true;
    },
    messagePlaceholder() {
      return (this.fields.message) ? '' : 'Message';
    },
    messageRequired() {
      return !this.fields.message;
    },
  },
  validations: {
    fields: {
      email: validators.email,
      subject: validators.required,
      message: validators.message,
    },
  },
  methods: {
    ...mapActions('popup', ['setCurrentSmallPopup', 'setCurrentPopupOptions']),
    ...mapActions('support', ['getTicketsTypes', 'postTicket', 'getAnnouncements']),
    ...mapActions('notifications', ['setErrorSideNotification', 'setSuccessSideNotification']),
    userDataHandler(value) {
      if (value && value.email) {
        this.fields.email = value.email;
      }
    },
    showAnnouncement(announcement) {
      if (!announcement.body) return;

      this.setCurrentSmallPopup(MODALS.SMALL_ANNOUNCEMENT);
      this.setCurrentPopupOptions({ announcement });
    },
    onSubmit() {
      if (this.formIsValid() && this.formDisable()) {
        this.loaderAdd(document.body);
        const formData = new FormData();
        formData.append('email', this.fields.email);
        formData.append('subject', this.fields.subject.value);
        formData.append('description', this.fields.message);


        this.files.forEach((file) => {
          formData.append('uploadedImage', file);
        });

        this.postTicket(formData)
        .then(() => {
          this.loaderRemove(document.body);
          this.setSuccessSideNotification(TICKET_SEND_MESSAGE);
          this.files = [];
          this.fields.message = '';
          this.fields.subject = null;
          this.formEnable();
        })
        .catch((error) => {
          this.loaderRemove(document.body);
          this.formHandleErrors(error);
        });
      }
    },
    onUpload() {
      this.$refs.fileinput.click();
    },
    fileToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve({
          name: file.name,
          file: reader.result,
        });
        reader.onerror = error => reject(error);
      });
    },
    onChange() {
      const files = this.$refs.fileinput.files;
      if (files.length) {
        this.files = [...this.files, ...files];
      }
    },
    fileRemove(index) {
      this.files = [
        ...this.files.slice(0, index),
        ...this.files.slice(index + 1),
      ];
    },
  },
  watch: {
    userData: {
      handler: 'userDataHandler',
      immediate: true,
    },
  },
  created() {
    this.loaderAdd(document.body);
    this.getTicketsTypes()
    .then(() => {
      return this.getAnnouncements()
        .then((data) => {
          this.announcements = data || [];
        }).then(() => this.loaderRemove(document.body))
    }).catch(() => {
      this.loaderRemove(document.body);
    });
  },
};



// WEBPACK FOOTER //
// ./src/components/support/help-and-support/help-and-support.js